import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../../context/Auth/AuthState";
import http from "../../helpers/http";
import { businessFormFiveLTURL, businessProfileEditURL2, loginURL } from "../../components/helpers/constant-words";
import config from "../../config/config";

const BusinessMagicLogin = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const base_url = config.api_url; // without trailing slash

  const auth = useAuth();

  const verifyToken = async (token) => {
    if (!token) {
      navigate(loginURL);
      return;
    }

    if (token) {
      const data = await http.post(`${base_url}/business/magic-login`, {
        token,
      });

     
      if (data?.data?.token) {
        const token = data?.data?.token;
        await auth.businessLogin(token,true,null,businessProfileEditURL2);
      } else {
        navigate(loginURL);
      }
    }
  };

  useEffect(() => {
    const token = searchParams.get("token");
    verifyToken(token);
  }, []);

  return <></>;
};

export default BusinessMagicLogin;
